import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAlerts } from '../../../views/site-selection/actions';

export interface AlertObject {
  id: number;
  createdAt: string;
  name: string;
  description: string;
  siteId: number;
  detergentId: number;
  type: number;
  acknowledged: boolean;
}

interface UseAlertsProps {
  alerts: AlertObject[];
  selectedType: number | null;
  filteringRead: boolean;
  primarySiteId: number;
  multiSiteSelection: any;
}

export const useAlerts = ({
  alerts,
  selectedType,
  filteringRead,
  primarySiteId,
  multiSiteSelection,
}: UseAlertsProps) => {
  const dispatch = useDispatch();
  const [filteredAlerts, setFilteredAlerts] = useState<AlertObject[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const getUnreadCount = (alertList: AlertObject[]): number => {
    if (alertList?.length) {
      return alertList.filter((a: AlertObject) => a.acknowledged === false).length;
    }
    return 0;
  };

  const filterAlerts = (type: number | null): AlertObject[] => {
    if (alerts) {
      if (type !== null) {
        if (filteringRead) {
          return alerts.filter((alert: AlertObject) => alert.type === type && !alert.acknowledged);
        }
        return alerts.filter((alert: AlertObject) => alert.type === type);
      } else {
        if (filteringRead) {
          return alerts.filter((alert: AlertObject) => !alert.acknowledged);
        }
        return alerts;
      }
    } else {
      return [];
    }
  };

  const getSiteNotifications = () => {
    dispatch(fetchAlerts());
  };

  useEffect(() => {
    const sortedArray = filterAlerts(selectedType);
    setFilteredAlerts(sortedArray);
    setUnreadCount(getUnreadCount(alerts));
  }, [alerts, selectedType, filteringRead]);

  useEffect(() => {
    getSiteNotifications();
  }, [primarySiteId, multiSiteSelection]);

  return {
    filteredAlerts,
    unreadCount,
  };
};
